import { render, staticRenderFns } from "./CatalogDrawerMetaPanel.vue?vue&type=template&id=274121cd&scoped=true"
import script from "./CatalogDrawerMetaPanel.vue?vue&type=script&lang=js"
export * from "./CatalogDrawerMetaPanel.vue?vue&type=script&lang=js"
import style0 from "./CatalogDrawerMetaPanel.vue?vue&type=style&index=0&id=274121cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274121cd",
  null
  
)

export default component.exports